import { logLevel } from './logLevel.js';

export function isError(): boolean {
	return logLevel() >= -1;
}